import styled, { keyframes } from "styled-components";

import { colors } from "src/assets/styles/settings";
import { ShimmerProps } from ".";

const backgroundMove = keyframes`
  0% {
    background-position: 100%;
  }

  100% {
    background-position: -100%;
  }
`;

export const colorTypes = {
  normal: "loading",
  light: "loading_light",
  orange: "loading_orange",
  green: "loading_green",
  blue: "loading_blue",
  red: "loading_red"
} as const;

export const Shimmered = styled.div<ShimmerProps>`
  animation: ${backgroundMove} 1s infinite;
  background: ${({ color }) => colors[colorTypes[color]]};
  background-size: 200%;
  border-radius: ${({ radius }) => (+radius ? `${radius}px` : radius)};
  height: ${({ height }) => (+height ? `${height}px` : height)};
  width: ${({ width }) => (+width ? `${width}px` : width)};
`;
